import script from "./AllNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./AllNotifications.vue?vue&type=style&index=0&id=060dfb2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060dfb2d"]])

export default __exports__